import { render, staticRenderFns } from "./LapStokBarangTgl.vue?vue&type=template&id=5bd4c6f0"
import script from "./LapStokBarangTgl.vue?vue&type=script&lang=js"
export * from "./LapStokBarangTgl.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports